import { render, staticRenderFns } from "./user-information.vue?vue&type=template&id=6dc91401&scoped=true&"
import script from "./user-information.vue?vue&type=script&lang=ts&"
export * from "./user-information.vue?vue&type=script&lang=ts&"
import style0 from "./user-information.vue?vue&type=style&index=0&id=6dc91401&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc91401",
  null
  
)

export default component.exports